import React, { useRef, lazy } from "react";
import Header from "./header";
import Footer from "./footer";
import { AiOutlineArrowUp } from "react-icons/ai";
import { ThemeContext } from "../context/ThemeContext";

import ModalMenu from "../components/modal-menu";
// import ModalSearch from "../components/modal-search";
// import { ParallaxProvider } from 'react-scroll-parallax';

import { FiMenu } from "react-icons/fi";
import { SuspenseHelper } from "./SuspenseHelper";
// import { useLocation } from "@reach/router";

const ModalSearch = lazy(() => import("../components/modal-search"));

const Layout = ({ children, postId, mainClass }) => {
  const scrollUpRef = useRef(null);
  // const location = useLocation();
  // useEffect(() => {
  //   handleCloseModalSearch();
  //   handleCloseModal();
  // }, [location]);
  return (
    <ThemeContext.Consumer>
      {({
        // isDark,
        showModal,
        showModalSearch,
        handleCloseModal,
        handleShowModal,
        scroll,
        isMobile,
      }) => {
        return (
          <>
            <Header postId={postId} siteTitle={`Caucasus Edition`} />

            <main ref={scrollUpRef} className={mainClass}>
              {children}
            </main>

            <Footer siteTitle={`Caucasus Edition`} />
            
            <ModalMenu
              showModal={showModal}
              handleCloseModal={handleCloseModal}
            ></ModalMenu>

            {showModalSearch ? (
              <SuspenseHelper fallback={<div></div>}>
                <ModalSearch
                ></ModalSearch>
              </SuspenseHelper>
            ) : null}

            {isMobile ? (
              <div
                className={
                  scroll ? "scroll-top on-scroll " : "scroll-top on-top "
                }
              >
                <button
                  aria-label="show modal menu"
                  className="with-icons "
                  onClick={() => handleShowModal()}
                >
                  <FiMenu />
                </button>
                <button
                  aria-label="scroll to top with-icons "
                  className="with-icons "
                  onClick={() => {
                    scrollUpRef.current.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  <AiOutlineArrowUp />
                </button>
              </div>
            ) : null}


          </>

          // </div>
        );
      }}
    </ThemeContext.Consumer>
  );
};

// Layout.propTypes = {
//   children: PropTypes.node.isRequired,
// }

export default Layout;
